export default {
  'projects.cohortsListPage.breadcrumbs.projects': 'Projects',
  'projects.cohortsListPage.breadcrumbs.cohorts': 'Cohorts',

  'cohortsList.pageHeader.title': 'Cohorts',
  'cohortsList.pageHeader.createCohortButton': 'Create cohort',

  'cohortsList.columnHeader.name': 'Name',
  'cohortsList.columnHeader.status': 'Status',
  'cohortsList.columnHeader.organization': 'Organization',
  'cohortsList.columnHeader.datasets': 'Data sets',
  'cohortsList.columnHeader.subjects': 'Subjects',
  'cohortsList.columnHeader.owner': 'Owner',
  'cohortsList.columnHeader.modifiedOn': 'Last modified',

  'projects.cohortsList.datagrid.noResults': 'No cohorts available.',
  'projects.cohortsList.datagrid.noRows': 'No cohorts available. Create a cohort to get started.',
  'projects.cohortsList.datagrid.errorMessage': 'An error occurred while fetching cohorts.',

  'cohortsList.createCohortModal.title': 'Create cohort',

  'cohortsList.createCohortModalContent.datasetReleaseLoading': 'Loading dataset releases',
  'cohortsList.createCohortModalContent.datasetReleaseError': 'Error loading dataset releases',

  'cohortsList.createCohortModal.saveButton': 'Create cohort',
  'cohortsList.createCohortModal.cancelButton': 'Cancel',
  'cohortsList.createCohortModal.submitting': 'Creating cohort',
  'cohortsList.createCohortModal.submittingError': 'Error submitting',
  'cohortsList.createCohortModal.closeButton': 'Close',
  'cohortsList.createCohortModal.success.title': 'Success',
  'cohortsList.createCohortModal.success.text': '"{cohortName}" was created successfully.',
  'cohortsList.createCohortModal.maxCharacterErrorMsg':
    'Max characters reached any additional character will be ignored',

  'cohortsList.deleteCohortModal.title': 'Delete cohort',
  'cohortsList.deleteCohortModal.description':
    "This action will permanently delete {cohortName}. The cohort's subjects and results will no longer be accessible.",
  'cohortsList.deleteCohortModal.deleteButton': 'Delete cohort',
  'cohortsList.deleteCohortModal.deletingButton': 'Deleting cohort',
  'cohortsList.deleteCohortModal.cancelButton': 'Cancel',
  'cohortsList.deleteCohortModal.submitting': 'Deleting cohort',
  'cohortsList.deleteCohortModal.submittingError': 'Error submitting',
  'cohortsList.deleteCohortModal.closeButton': 'Close',
  'cohortsList.deleteCohortModal.actionUndone': 'This action cannot be undone.',
  'cohortsList.deleteCohortModal.disableDeleteStatus':
    'This cohort is in {status} state and cannot be deleted.',
  'cohortsList.deleteCohortModal.success.title': 'Success',
  'cohortsList.deleteCohortModal.success.text': '"{cohortName}" was deleted successfully.',

  'cohortsList.renameCohortModal.title': 'Rename cohort',
  'cohortsList.renameCohortModal.deleteButton': 'Rename cohort',
  'cohortsList.renameCohortModal.deletingButton': 'Renaming cohort',
  'cohortsList.renameCohortModal.submitting': 'Renaming cohort',
  'cohortsList.renameCohortModal.success.text': 'Cohort was renamed successfully.',

  'cohortsList.exportCohortModal.path': 'Path',
  'cohortsList.exportCohortModal.cohort': 'Cohort',
  'cohortsList.exportCohortModal.location': 'Location',
  'cohortsList.exportCohortModal.project': 'Project',
  'cohortsList.exportCohortModal.title': 'Export cohort',
  'cohortsList.exportCohortModal.description':
    'Exporting will transport this cohort data to your desired location, enabling further analysis.',
  'cohortsList.exportCohortModal.projectName': 'Project name',
  'cohortsList.exportCohortModal.exportLocation': 'Export location',
  'cohortsList.exportCohortModal.exportLocationPlaceholder': 'Select export location',
  'cohortsList.exportCohortModal.schemaName': 'Schema',
  'cohortsList.exportCohortModal.schemaNamePlaceholder': 'Enter schema',
  'cohortsList.exportCohortModal.schemaNameHelptext': 'Schema can be renamed if needed.',
  'cohortsList.exportCohortModal.fileName': 'File name',
  'cohortsList.exportCohortModal.fileNamePlaceholder': 'Enter file name',
  'cohortsList.exportCohortModal.fileNameHelptext':
    'Only alphanumeric [A-Z] [0-9] [_] are allowed.',
  'cohortsList.exportCohortModal.fileType': 'File type',
  'cohortsList.exportCohortModal.fileType.csv': 'CSV',
  'cohortsList.exportCohortModal.fileType.parquet': 'Parquet',
  'cohortsList.exportCohortModal.exportButton': 'Export',
  'cohortsList.exportCohortModal.submitting': 'Exporting',
  'cohortsList.exportCohortModal.success.text':
    'Cohort data has started exporting with the following details:',

  'cohortsList.actionMenu.delete.label': 'Delete cohort',
  'cohortsList.actionMenu.rename.label': 'Rename cohort',
  'cohortsList.actionMenu.export.label': 'Export cohort',
  'cohortsList.actionMenu.copy.label': 'Copy cohort',

  'cohortsList.createCohortModal.cohortName.label': 'Cohort name',
  'cohortsList.createCohortModal.cohortName.placeholder': 'Enter a cohort name',
  'cohortsList.createCohortModal.dataset.label': 'Data set',
  'cohortsList.createCohortModal.dataset.placeholder': 'Select a data set',

  'cohortsList.copyCohortModal.title': 'Copy cohort',
  'cohortsList.copyCohortModal.description': 'Create a copy of this cohort with a new name.',
  'cohortsList.copyCohortModal.copyButton': 'Copy cohort',
  'cohortsList.copyCohortModal.cancelButton': 'Cancel',
  'cohortsList.copyCohortModal.submitting': 'Copying cohort',
  'cohortsList.copyCohortModal.submittingError': 'Error submitting',
  'cohortsList.copyCohortModal.closeButton': 'Close',
  'cohortsList.copyCohortModal.success.title': 'Success',
  'cohortsList.copyCohortModal.success.text': '"{cohortName}" was copied successfully.',
  'cohortsList.copyCohortModal.cohortName.label': 'New cohort name',
  'cohortsList.copyCohortModal.cohortName.placeholder': 'Enter a name for the copied cohort',
  'cohortsList.copyCohortModal.copyingCohort': 'Copying cohort "{cohortName}"',
};
